import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ChartUserByCountry from '../ChartUserByCountry';
import CustomizedTreeView from '../CustomizedTreeView';
import Copyright from '../internals/components/Copyright';
import { collection, getDocs } from "firebase/firestore";
import { useEffect, useState, useContext } from "react"; 
import { deleteDoc, doc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { db, storage } from "../../../firebase"; 
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { EventContext } from "../../../pages/Dashboard";
import SponsorAddForm from './SponsorAdd';
import SponsorEditModal from './SponsorEditModal';
import { useParams, } from "react-router-dom"; 
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {Dialog, DialogTitle, DialogContent, } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";

const Sponsors = ({ eventDocId }) => {
  const event = useContext(EventContext);
  const [guestRows, setGuestRows] = useState([]);
  const {eventDetails} = useContext(EventContext); 
  const eventCode = eventDetails?.eventCode;  
  const eventID = eventDetails?.eventId; 

  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEditSponsor = (sponsor) => {
    setSelectedSponsor(sponsor);
    setEditModalOpen(true);
  };

    const fetchSponsors = async () => {
      if (!eventID) return;

      const sponsorsRef = collection(db, "events", eventID, "sponsors");
      const snapshot = await getDocs(sponsorsRef);

      const rows = snapshot.docs.map((doc, index) => ({
        id: doc.id,
        sponsorName: doc.data().sponsorName,
        sponsorLogo: doc.data().sponsorLogo,        
      }));
      setGuestRows(rows);
    };

    const handleDeleteSponsor = async (sponsor) => {
      const confirm = window.confirm(
        `Are you sure you want to delete sponsor "${sponsor.sponsorName}"?`
      );
    
      if (!confirm || !eventID) return;
    
      try {
        // Delete logo from Storage (optional)
        if (sponsor.sponsorLogo) {
          const logoRef = ref(storage, sponsor.sponsorLogo);
          await deleteObject(logoRef).catch((err) => {
            console.warn("Couldn't delete logo from storage:", err.message);
          });
        }
    
        // Delete sponsor from Firestore
        await deleteDoc(doc(db, "events", eventID, "sponsors", sponsor.id));
        fetchSponsors(); // Refresh the list
      } catch (err) {
        console.error("Error deleting sponsor:", err.message);
      }
    };

    useEffect(() => {
      fetchSponsors();
    }, [event]);
  
  const columns = [
    { field: "sponsorName", headerName: "Sponsor", width: 250 },
    { field: "sponsorLogo", headerName: "Logo", width: 564 }, 
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => (
        <>
          <IconButton onClick={() => handleEditSponsor(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton onClick={() => handleDeleteSponsor(params.row)}>
            <DeleteIcon color="error" />
          </IconButton>
        </>
      ),
      sortable: false,
      filterable: false,
      width: 100,
    }
    
  ];

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      {/* <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Sponsors {eventID}
      </Typography>  */}
      
      <Stack  direction="row" spacing={2} mb={2} sx={{
        justifyContent: "flex-start",
        alignItems: "center",
        }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>Sponsors </Typography>
        <Button variant="outlined" >All items</Button>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setOpen(true)}>New sponsor</Button>
        <Button variant="outlined" startIcon={<DeleteIcon />}>Delete</Button>
        <Button variant="outlined" startIcon={<DeleteIcon />}>{t("language")}</Button>
      </Stack>
        
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }}>
        <DataGrid
        rows={guestRows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        pagination
        pageSizeOptions={[5, 10, 25]}
        slots={{ toolbar: GridToolbar }}
        initialState={{
          pagination: { paginationModel: { pageSize: 10, page: 0 } },
          sorting: { sortModel: [{ field: "guestEmail", sort: "asc" }] }
        }}
      />
         
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            <CustomizedTreeView />
            <ChartUserByCountry />
          </Stack>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Add New Sponsor</DialogTitle>
        <DialogContent>
          <SponsorAddForm
            onSponsorAdded={fetchSponsors}
            onClose={() => setOpen(false)}
          />
        </DialogContent>
      </Dialog>

      {selectedSponsor && (
        <SponsorEditModal
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          sponsor={selectedSponsor}
          onUpdated={fetchSponsors}
        />
      )}

      <Copyright sx={{ my: 4 }} />
    </Box>
  );
};
export default Sponsors;